import React from "react";
import styled from "styled-components";
import logo from "../assets/Farazandishan-logo-1.png";

const StyleCss = styled.div`
  padding: 0;
  margin: 0;
  background-color: var(--body-1);
  display: grid;
  grid-template-columns: 6.14% repeat(12, 5.62%) 6.14%;
  grid-gap: 1.56%;
  height: 100vh;
  width: 100%;
  box-sizing: content-box;
  .side-data {
    display: grid;
    grid-column: 1 / 6;
    grid-template-columns: 6.14vw repeat(4, 5.62vw);
    grid-column-gap: 1.56vw;
    grid-row-gap: 1vw;
    grid-auto-rows: 17vh 1fr;
    background-color: #fff;
    z-index: 10;
    .logo-podkadeh {
      margin-top: 56px;
      grid-column: 2 / 5;
      height: fit-content;
      img {
        max-width: 6.5rem;
        max-height: 5vh;
        object-fit: scale-down;
        display: block;
      }
    }
    .logo-farazandishan {
      margin-top: 56px;
      grid-column: 2 / 5;
      height: fit-content;
      img {
        max-width: 6.5rem;
        max-height: 5vh;
        object-fit: scale-down;
        display: block;
      }
    }
    .data {
      grid-column: 2 / 5;
      /* padding-bottom: 6rem; */
    }
  }
  .main-data {
    grid-column: 9 span;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--body-2);
    .center {
      max-width: 100%;
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      img {
        max-height: 100vh;
        object-fit: fill;
        filter: blur(20px);
        transform: scale(1.05) translateY(30px);
      }
      .box-overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 50%;
        height: 50%;
        background-color: #ffffff;
        box-shadow: 0px 5px -5px 15px #000;
        transform: translate(-50%, -50%);
        border-radius: 1rem;
        border: 1px solid #f38225;
        padding: 1rem;
        .title {
          font-size: 1.2rem;
          font-weight: 700;
        }
        .list {
          margin: 1rem 0;
          font-size: 1rem;
          padding: 0 0 0 0.9rem;
        }
        .offer {
          padding: 1rem 0.2rem;
          background-color: #f38225;
          text-align: center;
          color: #fff;
          font-weight: 600;
          border-radius: 0.5rem;
          a {
            text-decoration: none;
            color: inherit;
          }
        }
      }
    }
  }

  @media screen and (max-width: 800px) {
    flex-direction: column !important;
    display: flex !important;
    width: auto !important;
    align-items: center !important;
    box-sizing: content-box;
    .side-data {
      width: 100% !important;
      align-items: center !important;
      display: flex !important;
      flex-direction: column;
      .logo-podkadeh {
        margin: 3rem 7rem !important;
        max-width: 10rem !important;
        max-height: 5vh !important;
        display: flex !important;
        justify-content: center !important;
      }
      .logo-farazandishan {
        margin: 3rem 7rem !important;
        max-width: 20rem !important;
        max-height: 12vh !important;
        display: flex !important;
        justify-content: center !important;
      }
    }
    .box-overlay {
      width: calc(100% - 4rem);
      margin: 0 2rem;
      align-self: flex-start;
      .title {
        font-size: 1.2rem;
        font-weight: 700;
      }
      .list {
        margin: 1rem 0;
        font-size: 1rem;
        padding: 0 0 0 0.9rem;
      }
      .offer {
        width: 100%;
        padding: 1rem 0.2rem;
        background-color: #f38225;
        text-align: center;
        color: #fff;
        font-weight: 600;
        border-radius: 0.5rem;
        a {
          text-decoration: none;
          color: inherit;
        }
      }
    }
    .data {
      width: 65%;
      display: flex !important;
    }
  }
`;

function LoginLayout({ image, children, styled, stylemaindata, stylelogo }) {
  if (window.innerWidth > 800) {
    return (
      <StyleCss>
        <div className="side-data">
          <div className="logo-podkadeh" style={stylelogo}>
            <img src={logo} alt="Shenidesho Podkadeh" style={styled} />
          </div>
          {children}
        </div>
        <div className="main-data" style={stylemaindata}>
          <div className="center">
            <div className="spacer-l" />
            <img src={image} alt="description" />
            <div className="box-overlay ">
              <div className="title">Panel description</div>
              <ul className="list">
                <li>Send Resume</li>
                <li>Send Documents</li>
                <li>See Contracts</li>
                <li>See Payments</li>
              </ul>
              <div className="offer">
                <a href="https://farazandishan.com/en/lotus-blog/blog?id=24" target="_blank">see the amazing offers of goergia tour</a>
              </div>
            </div>
          </div>
        </div>
      </StyleCss>
    );
  } else {
    return (
      <StyleCss>
        <div className="side-data" style={stylelogo}>
          <img
            className="logo-farazandishan"
            src={logo}
            alt="panel"
            style={styled}
          />
          {children}
          <div className="box-overlay ">
            <div className="title">Panel description</div>
            <ul className="list">
              <li>Send Resume</li>
              <li>Send Documents</li>
              <li>See Contracts</li>
              <li>See Payments</li>
            </ul>
            <div className="offer">
              <a href="https://farazandishan.com/en/lotus-blog/blog?id=24" target="_blank">see the amazing offers of goergia tour</a>
            </div>
          </div>
        </div>
      </StyleCss>
    );
  }
}

export default LoginLayout;
